import { useUID as originalUseUID } from "react-uid";

import { useTheme } from "@catchoftheday/theme";
export { UIDReset } from "react-uid";

export const useUID: typeof originalUseUID = () => {
  const { appName } = useTheme();
  const id = originalUseUID();

  return `${appName}-${id}`;
};
